import { createFileRoute } from '@tanstack/react-router'
import {
  parseLocalizedMatchDetailSearch,
  parseMatchDetailSearch,
} from '~/features/football-match-detail/back-navigation'
import { FootballMatchDetailRouteModule } from '~/features/football-match-detail/route-module'
import {
  loadFootballMatchDetailRoute,
  validateFootballMatchDetailRouteParams,
} from '~/features/football-match-detail/route-options'
import { footballCoreLocale } from '~/lib/navigation/football-core'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/$locale/matches/$matchId')({
  validateSearch: parseLocalizedMatchDetailSearch,
  beforeLoad: ({ params, search }) => {
    validateFootballMatchDetailRouteParams(params)
    parseMatchDetailSearch(search, footballCoreLocale(params.locale))
  },
  head: ({ params }) => seo({
    title: '足球比赛详情 | BallPeek',
    description: '优先展示比分、足球事实、阵容、球员链接、历史资料和已审核背景。',
    pathname: `/matches/${encodeURIComponent(params.matchId)}`,
    locale: params.locale,
  }),
  loader: loadFootballMatchDetailRoute,
  component: LocalizedMatchDetailRoute,
})

function LocalizedMatchDetailRoute() {
  const { locale, matchId } = Route.useParams()
  return (
    <FootballMatchDetailRouteModule
      matchId={matchId}
      locale={locale === 'zh-CN' ? 'zh-CN' : 'en'}
      back={Route.useSearch().back}
    />
  )
}
